import { Component, Input } from '@angular/core';

import { OrganizationConfigService } from '../../../../../services/organization-config/organization-config.service';
import { formatCell, ReportCellType } from '../../../../../reporting-core/cell-format';


@Component({
  selector: 'app-generic-table-cell',
  templateUrl: './generic-table-cell.component.html',
  styleUrls: ['./generic-table-cell.component.css']
})
export class GenericTableCellComponent {
  @Input() content: string;
  @Input() column: string;
  @Input() objectIDColumns: string[] = [];
  @Input() currencyColumns: string[] = [];
  @Input() dateColumns: string[] = [];

  // Exposed so the template can compare against ReportCellType members.
  public readonly ReportCellType = ReportCellType;

  constructor(
    public orgConfigService: OrganizationConfigService,
  ) {}

  get columnType(): ReportCellType {
    if (this.objectIDColumns.includes(this.column)) { return ReportCellType.objectId; }
    if (this.currencyColumns.includes(this.column)) { return ReportCellType.currency; }
    if (this.dateColumns.includes(this.column)) { return ReportCellType.date; }
    return ReportCellType.text;
  }

  /**
   * The display value, or null when the cell has no value (the template then
   * renders the muted "None"). Value logic lives in the framework-agnostic
   * formatCell so the emailed-reports renderer produces identical output.
   */
  get formattedValue(): string | null {
    return formatCell(this.content, this.columnType, {
      currencySymbol: this.orgConfigService.getCurrencySymbol(),
      timezone: null,
    });
  }
}
